import React from 'react';
import { createUltimatePagination, ITEM_TYPES, PaginationComponentProps } from 'react-ultimate-pagination';
import numeral from 'numeral';

const WrapperComponent = (props: any) => {
  return (
    <ul className="pagination light-shadow"
      style={{ display: 'flex', padding: '0 0 0 2px' }}
    >{props.children}</ul>
  )
}

const Page = ({ value, isActive, onClick }: PaginationComponentProps) => (
  <li className={'page-item ' + (isActive ? 'active' : undefined)} style={{ marginLeft: '-1px' }}>
    <button
      tabIndex={0}
      style={{ cursor: 'pointer', marginLeft: '-1px', width: '100%' }}
      onClick={onClick}
      onKeyUp={((event: React.KeyboardEvent) => {
        if (event.key == 'Enter') {
          onClick();
        }
      })}
      className='page-link'
    >{numeral(value).format('0,0')}</button>
  </li>
);

const Ellipsis = ({ onClick }: PaginationComponentProps) => (
  <li className='page-item' style={{ marginLeft: '-1px' }}>
    <button
      tabIndex={0}
      style={{ cursor: 'pointer', marginLeft: '-1px', width: '100%' }}
      onClick={onClick}
      onKeyUp={((event: React.KeyboardEvent) => {
        if (event.key == 'Enter') {
          onClick();
        }
      })}
      className='page-link'
    >...</button>
  </li>
);

const FirstPageLink = ({ onClick }: PaginationComponentProps) => (
  <li className='page-item d-none d-sm-block' style={{ marginLeft: '-1px' }}>
    <button
      tabIndex={0}
      style={{ cursor: 'pointer', marginLeft: '-1px', width: '100%' }}
      onClick={onClick}
      onKeyUp={((event: React.KeyboardEvent) => {
        if (event.key == 'Enter') {
          onClick();
        }
      })}
      className='page-link'
    >&laquo;</button>
  </li>
);

const PreviousPageLink = ({ onClick }: PaginationComponentProps) => (
  <li className='page-item d-none d-sm-block' style={{ marginLeft: '-1px' }}>
    <button
      tabIndex={0}
      style={{ cursor: 'pointer', marginLeft: '-1px', width: '100%' }}
      onClick={onClick}
      onKeyUp={((event: React.KeyboardEvent) => {
        if (event.key == 'Enter') {
          onClick();
        }
      })}
      className='page-link'
    >&lsaquo;</button>
  </li>
);

const NextPageLink = ({ onClick }: PaginationComponentProps) => (
  <li className='page-item d-none d-sm-block' style={{ marginLeft: '-1px' }}>
    <button
      tabIndex={0}
      style={{ cursor: 'pointer', marginLeft: '-1px', width: '100%' }}
      onClick={onClick}
      onKeyUp={((event: React.KeyboardEvent) => {
        if (event.key == 'Enter') {
          onClick();
        }
      })}
      className='page-link'
    >&rsaquo;</button>
  </li>
);

const LastPageLink = ({ onClick }: PaginationComponentProps) => (
  <li className='page-item d-none d-sm-block' style={{ marginLeft: '-1px' }}>
    <button
      tabIndex={0}
      style={{ cursor: 'pointer', marginLeft: '-1px', width: '100%' }}
      onClick={onClick}
      onKeyUp={((event: React.KeyboardEvent) => {
        if (event.key == 'Enter') {
          onClick();
        }
      })}
      className='page-link'
    >&raquo;</button>
  </li>
);

const itemTypeToComponent = {
  [ITEM_TYPES.PAGE]: Page,
  [ITEM_TYPES.ELLIPSIS]: Ellipsis,
  [ITEM_TYPES.FIRST_PAGE_LINK]: FirstPageLink,
  [ITEM_TYPES.PREVIOUS_PAGE_LINK]: PreviousPageLink,
  [ITEM_TYPES.NEXT_PAGE_LINK]: NextPageLink,
  [ITEM_TYPES.LAST_PAGE_LINK]: LastPageLink
};

export default createUltimatePagination({ itemTypeToComponent, WrapperComponent });
